export default __webpack_public_path__ + "locales/ar-SA/Errors.json?hash=035c62084941733a7328cb365628fa5e";